import { apiGet } from '@/lib/api'
import type { SearchResult } from './types'

export function searchPlatform(text: string): Promise<SearchResult> {
  return apiGet<SearchResult>(`/api/v1/search?q=${encodeURIComponent(text)}`)
}
